<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 17:14:48
 * @LastEditTime: 2020-07-16 17:15:21
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: 'JurisprudenceDaily',
}
</script>